import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdminStore = create(
  persist(
    (set, get) => ({
      admin: null,
      adminToken: null,
      isAdminAuthenticated: false,
      isLoading: false,
      error: null,

      adminLogin: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
          const res = await fetch(`${BACKEND_URL}/api/admin/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.detail || 'Login failed');
          localStorage.setItem('adminToken', data.access_token);
          set({ admin: data.admin, adminToken: data.access_token, isAdminAuthenticated: true, isLoading: false });
          return true;
        } catch (err) {
          set({ error: err.message, isLoading: false });
          return false;
        }
      },

      adminLogout: () => {
        localStorage.removeItem('adminToken');
        set({ admin: null, adminToken: null, isAdminAuthenticated: false });
      },

      fetchAdmin: async () => {
        const token = localStorage.getItem('adminToken');
        if (!token) return;
        try {
          const res = await fetch(`${BACKEND_URL}/api/admin/me`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (!res.ok) throw new Error('Invalid token');
          const data = await res.json();
          set({ admin: data, adminToken: token, isAdminAuthenticated: true });
        } catch (err) {
          localStorage.removeItem('adminToken');
          set({ admin: null, adminToken: null, isAdminAuthenticated: false });
        }
      },

      setupFirstAdmin: async (data) => {
        set({ isLoading: true, error: null });
        try {
          const res = await fetch(`${BACKEND_URL}/api/admin/setup`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });
          const result = await res.json();
          if (!res.ok) throw new Error(result.detail || 'Setup failed');
          set({ isLoading: false });
          return true;
        } catch (err) {
          set({ error: err.message, isLoading: false });
          return false;
        }
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'admin-storage',
      partialize: (state) => ({
        adminToken: state.adminToken,
        admin: state.admin,
      }),
    }
  )
);
